import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismLoadingBar } from '@mylighthouse/prism-ember';
import { ICONS_LOGOS_MAP } from '@mylighthouse/prism-foundation';
import { t } from 'ember-intl';
import { FocusScreen, StepIndicator } from 'frontend-utils';
import HotelWizardsPreferredRateOnboardingPreferredRateOnboardingOptions from 'lumen/components/hotel/wizards/preferred-rate-onboarding/preferred-rate-onboarding-options';
import type HotelWizardsPreferredRateOnboardingPersonsController from 'lumen/controllers/hotel/wizards/preferred-rate-onboarding/persons';
import { PREFERRED_RATE_ONBOARDING_TOTAL_STEPS } from 'lumen/utils/constants/preferred-rate-onboarding';

interface HotelWizardsPreferredRateOnboardingPersonsSignature {
  Args: {
    controller: HotelWizardsPreferredRateOnboardingPersonsController;
    model: unknown;
  };
}

<template>
  <FocusScreen
    @hasCancel={{false}}
    @isCancelDisabled={{true}}
    @logoHtml={{ICONS_LOGOS_MAP.logo-dark-with-text}}
  >
    <:header>
      <div class="wizards-preferred-rate-onboarding__header">
        <h3>{{t "wizards.preferred_rate_onboarding.header"}}</h3>
        <div class="wizards-preferred-rate-onboarding__header__step-indicator">
          <StepIndicator
            @currentStep={{3}}
            @steps={{PREFERRED_RATE_ONBOARDING_TOTAL_STEPS}}
          />
        </div>
      </div>
    </:header>

    <:body>
      <div class="wizards-preferred-rate-onboarding__body">
        {{#if
          @controller.model.requestPricingAssistantRatePreferencesOptionsTaskResult.isRunning
        }}
          <PrismLoadingBar />
        {{else}}
          <div class="wizards-preferred-rate-onboarding__content">
            <h1 class="mb-400">
              {{t "wizards.preferred_rate_onboarding.persons.content.title"}}
            </h1>

            <h4 class="text-300--regular mb-600">
              {{t
                "wizards.preferred_rate_onboarding.persons.content.sub_title"
              }}
            </h4>

            {{#unless
              @controller.model.requestPricingAssistantRatePreferencesOptionsTaskResult.isRunning
            }}
              <HotelWizardsPreferredRateOnboardingPreferredRateOnboardingOptions
                @options={{@controller.personsOptions}}
                @updateOption={{@controller.updateSelectedPersons}}
              />
            {{/unless}}
          </div>
        {{/if}}
      </div>
    </:body>

    <:footer>
      <div
        class="wizards-preferred-rate-onboarding__footer wizards-preferred-rate-onboarding__footer--with-back-button"
      >
        <PrismButton
          @buttonType="ghost"
          @iconBefore="arrow-left"
          @label={{t "general.back"}}
          @onClick={{@controller.onBack}}
          @size="large"
        />

        <div class="flex gap-300">
          <PrismButton
            @buttonType="secondary"
            @label={{t "general.user_details_skip_button"}}
            @onClick={{@controller.onSkip}}
            @size="large"
          />

          <PrismButton
            @buttonType="brand"
            @iconAfter="arrow-right"
            @label={{t "general.continue"}}
            @onClick={{@controller.onContinue}}
            @size="large"
          />
        </div>
      </div>
    </:footer>
  </FocusScreen>
</template> satisfies TOC<HotelWizardsPreferredRateOnboardingPersonsSignature>;
